<template>
    <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
export default {
    data() {
        return {
            chartOptions: {
                chart: {
                    id: 'leadsPerStudio',
                },
                xaxis: {
                    categories: this.leadsPerStudio.map((item) => item.name),
                    labels: {
                        style: {
                            colors: '#FFFFFF', // Set the color to white
                        },
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#FFFFFF', // Set the color to white
                        },
                    },
                },
            },
            series: [
                {
                    name: 'Leads',
                    data: this.leadsPerStudio.map((item) => item.data),
                },
            ],
        }
    },
    props: {
        leadsPerStudio: Array,
    },
}
</script>
 